module.exports = __webpack_public_path__ + "static/media/jhon_and_george_thumb.ce4ad8fe.webp";